import { GroupType } from '@kcftech/prometheus-client';
import { TreeItemType } from 'utils/tree';

export function getGroupTypeUserFriendlyName(
    type: GroupType | TreeItemType,
    isDynamicSystem: boolean = false,
) {
    switch (type) {
        case GroupType.System:
            return isDynamicSystem ? 'Dynamic System' : 'System';
        case GroupType.Assembly:
            return 'Assembly';
        case GroupType.Asset:
            return 'Asset';
        case GroupType.MonitoringPoint:
            return 'Monitoring Point';
        case GroupType.IndicatorGroup:
            return 'Indicator Group';
        case GroupType.AnalyticModel:
            return 'Analytic Model';
        case GroupType.Group:
            return 'Group';
        default:
            return `Type not supported ${type}`;
    }
}
